// src/pages/About.js 
import React from 'react'

const About = () => {
  return (
    <div className='content pageStyle'>
        <h1 className='pageTitle'>About Us</h1>
        <div className='divider'></div>
        <p className='pageContent'>Heave to capstan Plate Fleet aft fathom scallywag gibbet. To go on account boom topsail league brig bilge schooner.</p>
    </div>
  )
}

export default About 